<ng-container *resolve="currentStep$ | async as currentStep">
    <section
        *ngIf="currentStep === CitizenIntroductionSteps.Welcome"
        class="page flex items-center justify-center h-dvh w-screen bg-center bg-cover welcome-step"
    >
        <div
            class="flex flex-col items-center justify-center gap-24 p-20 m-20 bg-slate-300/10 rounded-3xl border border-slate-300/20 backdrop-blur-sm"
        >
            <div class="flex flex-col items-center justify-center gap-12">
                <div class="flex gap-20 items-center justify-between h-20">
                    <img src="/assets/images/logo-rigaud_white.svg" />
                    <mat-icon class="text-white" svgIcon="streamline-regular:close" />
                    <img src="/assets/images/logo-municipal_white.svg" />
                </div>

                <div class="flex flex-col items-center justify-center gap-5">
                    <p class="large-title text-white text-8xl leading-normal text-center text-balance">
                        {{ "features.dashboard.citizen_introduction.welcome.title" | translate }}
                    </p>

                    <p class="title text-white text-center text-balance">
                        {{ "features.dashboard.citizen_introduction.welcome.description" | translate }}
                    </p>
                </div>

                <div>
                    <p class="text-white text-center text-balance">
                        {{ "features.dashboard.citizen_introduction.welcome.next_step" | translate }}
                    </p>
                </div>
            </div>

            <button mat-flat-button class="min-w-64" color="accent" (click)="setNextStep()">
                {{ "general.next" | translate }}
            </button>
        </div>
    </section>

    <section
        *ngIf="currentStep === CitizenIntroductionSteps.Visit"
        class="relative page flex flex-col items-center justify-center gap-12 h-full"
    >
        <button mat-icon-button class="absolute top-12 right-12" (click)="skipIntroduction()">
            <mat-icon class="icon-size-4" color="accent" svgIcon="streamline-regular:close" />
        </button>

        <img class="max-w-256" src="/assets/images/citizen-introduction_visit.png" />

        <div class="max-w-256 flex flex-col justify-center items-center gap-12">
            <div class="flex flex-col justify-center items-center gap-4">
                <span class="large-title">
                    {{ "features.dashboard.citizen_introduction.visit.title" | translate }}
                </span>

                <p class="text-center text-balance">
                    {{ "features.dashboard.citizen_introduction.visit.description" | translate }}
                </p>
            </div>

            <div class="flex gap-4">
                <button mat-flat-button color="accent" (click)="setNextStep()">
                    {{ "general.next" | translate }}
                </button>
            </div>
        </div>
    </section>

    <section
        *ngIf="currentStep === CitizenIntroductionSteps.Responsibility"
        class="relative page flex flex-col items-center justify-center gap-12 h-full"
    >
        <button mat-icon-button class="absolute top-12 right-12" (click)="skipIntroduction()">
            <mat-icon class="icon-size-4" color="accent" svgIcon="streamline-regular:close" />
        </button>

        <img class="max-w-256" src="/assets/images/citizen-introduction_responsibility.png" />

        <div class="max-w-256 flex flex-col justify-center items-center gap-12">
            <div class="flex flex-col justify-center items-center gap-4">
                <span class="large-title">
                    {{ "features.dashboard.citizen_introduction.responsibility.title" | translate }}
                </span>

                <p class="text-center text-balance">
                    {{ "features.dashboard.citizen_introduction.responsibility.description" | translate }}
                </p>
            </div>

            <div class="flex gap-4">
                <button mat-stroked-button color="accent" (click)="setPreviousStep()">
                    {{ "general.previous" | translate }}
                </button>

                <button mat-flat-button color="accent" (click)="setNextStep()">
                    {{ "general.next" | translate }}
                </button>
            </div>
        </div>
    </section>

    <section
        *ngIf="currentStep === CitizenIntroductionSteps.SuppliersAndPayment"
        class="relative page flex flex-col items-center justify-center gap-12 h-full"
    >
        <button mat-icon-button class="absolute top-12 right-12" (click)="skipIntroduction()">
            <mat-icon class="icon-size-4" color="accent" svgIcon="streamline-regular:close" />
        </button>

        <img class="max-w-256" src="/assets/images/citizen-introduction_suppliers_and_payment.png" />

        <div class="max-w-256 flex flex-col justify-center items-center gap-12">
            <div class="flex flex-col justify-center items-center gap-4">
                <span class="large-title">
                    {{ "features.dashboard.citizen_introduction.suppliers_and_payment.title" | translate }}
                </span>

                <p class="text-center text-balance">
                    {{ "features.dashboard.citizen_introduction.suppliers_and_payment.description" | translate }}
                </p>
            </div>

            <div class="flex gap-4">
                <button mat-stroked-button color="accent" (click)="setPreviousStep()">
                    {{ "general.previous" | translate }}
                </button>

                <button mat-flat-button color="accent" (click)="skipIntroduction()">
                    {{ "features.dashboard.citizen_introduction.visit.complete" | translate }}
                </button>
            </div>
        </div>
    </section>
</ng-container>
